var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7492 47.3334C41.763 46.8064 41.6693 46.2824 41.4742 45.7927C41.2787 45.3031 40.9858 44.8584 40.6132 44.4857C40.2403 44.1129 39.7957 43.8201 39.3062 43.6247C38.8165 43.4296 38.2923 43.3357 37.7653 43.3497H36.9687C36.9845 43.2301 36.9687 42.6756 36.9687 42.5529C36.9687 41.0407 35.297 40.1626 33.7817 40.1626L20.2368 40.1467C18.7246 40.1467 17.0498 41.0216 17.0498 42.5369C17.0498 42.6597 17.0339 43.2142 17.0498 43.3337H16.2531C15.7263 43.3204 15.2023 43.4144 14.7129 43.6097C14.2235 43.8052 13.7791 44.0981 13.4064 44.4709C13.0338 44.8434 12.7409 45.2881 12.5454 45.7774C12.3499 46.2667 12.256 46.7907 12.2693 47.3176L41.7492 47.3334Z",
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5223 28.1953L21.1646 28.8981C20.6453 29.1665 20.2098 29.5723 19.9057 30.0713C19.6017 30.5705 19.4407 31.1436 19.4404 31.7281V36.268C19.4405 36.4121 19.4797 36.5536 19.5537 36.6773C19.6278 36.8008 19.7341 36.9021 19.8611 36.97C19.9882 37.038 20.1313 37.0703 20.2752 37.0635C20.4192 37.0565 20.5586 37.0108 20.6786 36.931L24.2209 34.5693",
    fill: "#FF808C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5223 28.1953L21.1646 28.8981C20.6453 29.1665 20.2098 29.5723 19.9057 30.0713C19.6017 30.5705 19.4407 31.1436 19.4404 31.7281V36.268C19.4405 36.4121 19.4797 36.5536 19.5537 36.6773C19.6278 36.8008 19.7341 36.9021 19.8611 36.97C19.9882 37.038 20.1313 37.0703 20.2752 37.0635C20.4192 37.0565 20.5586 37.0108 20.6786 36.931L24.2209 34.5693",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.297 28.1953L33.6547 28.8981C34.1735 29.1668 34.6084 29.573 34.9117 30.072C35.2154 30.5711 35.3757 31.144 35.3757 31.7281V36.268C35.3757 36.4121 35.3365 36.5536 35.2625 36.6773C35.1884 36.8008 35.082 36.9021 34.955 36.97C34.828 37.038 34.6849 37.0703 34.5409 37.0635C34.397 37.0565 34.2575 37.0108 34.1375 36.931L30.5952 34.5693",
    fill: "#FF808C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.297 28.1953L33.6547 28.8981C34.1735 29.1668 34.6084 29.573 34.9117 30.072C35.2154 30.5711 35.3757 31.144 35.3757 31.7281V36.268C35.3757 36.4121 35.3365 36.5536 35.2625 36.6773C35.1884 36.8008 35.082 36.9021 34.955 36.97C34.828 37.038 34.6849 37.0703 34.5409 37.0635C34.397 37.0565 34.2575 37.0108 34.1375 36.931L30.5952 34.5693",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5952 40.9433C30.5952 43.1741 27.4082 44.927 27.4082 44.927C27.4082 44.927 24.2212 43.1741 24.2212 40.9433C24.2212 38.7123 26.3978 38.553 27.4082 38.553C28.4185 38.553 30.5952 38.7123 30.5952 40.9433Z",
    fill: "#FFEF5E",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4092 13.8538V12.2603",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1558 10.6667V13.8538",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 12.2603H38.563",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5309 25.0084H43.822C43.3747 25.0049 42.9384 25.1463 42.578 25.4115C42.2177 25.6766 41.953 26.0511 41.8234 26.4794C41.6937 26.9074 41.706 27.3659 41.8585 27.7864C42.0112 28.2069 42.2959 28.5668 42.6699 28.8121L45.6019 30.7658C45.9752 31.0106 46.2594 31.3694 46.4122 31.7891C46.565 32.2084 46.578 32.6661 46.4497 33.0938C46.3212 33.5214 46.0582 33.8959 45.6994 34.1619C45.3407 34.4278 44.9059 34.5708 44.4594 34.5694H41.7504",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.936 25.0083V23.4148",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3433 36.1628V34.5693",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2541 12.2603H13.5451C13.0982 12.2579 12.6626 12.4001 12.3031 12.6656C11.9437 12.9311 11.6797 13.3057 11.5507 13.7336C11.4216 14.1614 11.4344 14.6195 11.587 15.0395C11.7397 15.4595 12.0241 15.8189 12.3978 16.064L15.3298 18.0176C15.7035 18.2627 15.9879 18.6221 16.1406 19.0421C16.2932 19.4621 16.306 19.9202 16.1769 20.348C16.0479 20.7759 15.7839 21.1505 15.4245 21.416C15.065 21.6816 14.6294 21.8237 14.1825 21.8213H11.4735",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 12.2602V10.6667",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0674 23.4148V21.8213",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1895 17.8375L27.409 13.8538L22.6285 17.8375C21.9413 18.4047 21.4274 19.1537 21.1456 19.9991C20.8638 20.8444 20.8255 21.752 21.035 22.618L24.222 34.5693H30.596L33.783 22.618C33.9927 21.752 33.9542 20.8444 33.6725 19.9991C33.3907 19.1537 32.8768 18.4047 32.1895 17.8375Z",
    fill: "#E3E3E3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6451 24.8999C21.9099 24.4724 22.2419 24.0904 22.6283 23.7686C23.97 22.6496 25.6617 22.0367 27.4088 22.0367C29.156 22.0367 30.8477 22.6496 32.1893 23.7686C32.5762 24.0903 32.9088 24.4723 33.1742 24.8999L33.7828 22.618C33.9922 21.752 33.9537 20.8445 33.672 19.9992C33.3902 19.1539 32.8765 18.4048 32.1893 17.8375L27.4088 13.8538L22.6283 17.8375C21.9412 18.4048 21.4275 19.1539 21.1457 19.9992C20.8639 20.8445 20.8255 21.752 21.0348 22.618L21.6451 24.8999Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1895 17.8375L27.409 13.8538L22.6285 17.8375C21.9413 18.4047 21.4274 19.1537 21.1456 19.9991C20.8638 20.8444 20.8255 21.752 21.035 22.618L24.222 34.5693H30.596L33.783 22.618C33.9927 21.752 33.9542 20.8444 33.6725 19.9991C33.3907 19.1537 32.8768 18.4047 32.1895 17.8375Z",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4083 24.2114C27.8812 24.2114 28.3432 24.0713 28.7363 23.8086C29.1293 23.546 29.4357 23.1727 29.6167 22.7359C29.7977 22.2991 29.845 21.8185 29.7527 21.3549C29.6605 20.8912 29.4327 20.4653 29.0985 20.131C28.7642 19.7967 28.3383 19.5691 27.8745 19.4768C27.411 19.3846 26.9305 19.432 26.4937 19.6129C26.0568 19.7938 25.6835 20.1001 25.4209 20.4932C25.1583 20.8863 25.0181 21.3484 25.0181 21.8212C25.0181 22.4551 25.2699 23.0631 25.7182 23.5113C26.1663 23.9596 26.7745 24.2114 27.4083 24.2114Z",
    fill: "#66E1FF",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2369 40.1467C18.7247 40.1467 17.0499 41.0247 17.0499 42.5369C17.0499 42.6597 17.034 43.2142 17.0499 43.3337H16.2532C15.7262 43.3199 15.202 43.4136 14.7125 43.6087C14.2229 43.8041 13.7782 44.0971 13.4055 44.4697C13.0328 44.8424 12.7398 45.2872 12.5445 45.7767C12.3492 46.2664 12.2556 46.7906 12.2694 47.3176",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7817 40.1467C35.2941 40.1467 36.9687 41.0247 36.9687 42.5369C36.9687 42.6597 36.9847 43.2142 36.9687 43.3337H37.7656C38.2926 43.3199 38.8166 43.4136 39.3064 43.6087C39.7959 43.8041 40.2406 44.0971 40.6132 44.4697C40.9861 44.8424 41.2789 45.2872 41.4742 45.7767C41.6696 46.2664 41.7632 46.7906 41.7494 47.3176",
    stroke: "#191919",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostIcon);
export default __webpack_public_path__ + "static/media/BoostIcon.9c73dd652b8bc98a7d84df399ee8dfd3.svg";
export { ForwardRef as ReactComponent };